import { Outlet, Navigate ,useLocation, redirect} from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = () => {
    const location = useLocation()
    const local = location.pathname
    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin
    
    var redirect = "/login?redirect="+local

    return (
         !userInfo ? <Navigate to={redirect} /> : <Outlet/>
       // <Route {...rest}>{children}</Route>
         
    )
}

export default PrivateRoute


